<template>
  <vue-editor
    v-model="modelValue"
    @input="$emit('input', $event)"
    :editorToolbar="attribute.editorToolbar"
  >
  </vue-editor>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      type: Object
    }
  },
  data() {
    return {
      modelValue: this.value
    };
  }
};
</script>

<style></style>
